import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

/** About a screenful of rows, so the card does not jump when the data lands. */
const DEFAULT_ROW_COUNT = 9;
const ROW_HEIGHT = 32;

interface SkeletonCardProps {
  rowCount?: number;
}

/** The loading state of the รับจ่าย screens: placeholder rows on a card. */
export default function SkeletonCard({ rowCount = DEFAULT_ROW_COUNT }: Readonly<SkeletonCardProps>) {
  return (
    <Paper>
      <Stack gap={1.25} aria-busy>
        {Array.from({ length: rowCount }, (_, index) => (
          <Skeleton key={index} variant="rounded" height={ROW_HEIGHT} />
        ))}
      </Stack>
    </Paper>
  );
}
